import { useState } from 'react';
import css from './FilterSection.module.css';

const FilterSectionWithOptions = ({
  title,
  sizeType,
  options,
  selectedOptions,
  onChange,
  onSizeTypeChange,
  isScrollable = false,
  isGrid = false,
}) => {
  const [isExpanded, setIsExpanded] = useState(!!selectedOptions);

  const normalizeOptions = opts => {
    return opts.map(opt => {
      if (typeof opt === 'string') {
        return { value: opt, label: opt };
      }
      return opt;
    });
  };

  const normalizedOptions = normalizeOptions(options);

  return (
    <div className={css.section}>
      <button className={css.header} onClick={() => setIsExpanded(!isExpanded)}>
        <span className={`${css.triangle} ${isExpanded ? css.expanded : ''}`}>▲</span>
        <h2 className={css.title}>{title}</h2>
      </button>

      {isExpanded && (
        <>
          <div className={css.sizeTypeContainer}>
            <label className={css.sizeTypeLabel}>
              <input
                type="radio"
                name="sizeType"
                value="clothing"
                checked={sizeType === 'clothing'}
                onChange={() => onSizeTypeChange('clothing')}
                className={css.radio}
              />
              <span className={css.sizeTypeText}>CLOTHING</span>
            </label>
            <label className={css.sizeTypeLabel}>
              <input
                type="radio"
                name="sizeType"
                value="shoes"
                checked={sizeType === 'shoes'}
                onChange={() => onSizeTypeChange('shoes')}
                className={css.radio}
              />
              <span className={css.sizeTypeText}>SHOES</span>
            </label>
          </div>
          <div
            className={`${css.content} ${isScrollable ? css.scrollable : ''} ${
              isGrid ? css.grid : ''
            }`}
          >
            {normalizedOptions.map(option => (
              <label key={`size-${option.value}`} className={css.optionLabel}>
                <input
                  type="radio"
                  name={`filter-${sizeType}`}
                  value={option.value}
                  checked={selectedOptions === option.value}
                  onChange={() => onChange(option.value)}
                  className={css.radio}
                />
                <span className={css.optionText}>{option.label}</span>
              </label>
            ))}
          </div>
        </>
      )}
    </div>
  );
};

export default FilterSectionWithOptions;
